export default __webpack_public_path__ + "static/media/1059.5ec78fb9.png";